import { QUESTION_PRICES } from '@/plugins/global-mixins/prices';

/**
 * @param {string} region - 'cz' | 'sk' | 'hu'
 * @returns {number}
 */
export function getQuestionDefaultPrice(region) {
  return region === 'cz' ? QUESTION_PRICES.czk : QUESTION_PRICES.eur;
}

/**
 * @param {string} region - 'cz' | 'sk' | 'hu'
 * @returns {string}
 */
export function getQuestionCurrencyLabel(region) {
  return region === 'cz' ? 'Kč' : 'EUR';
}

/**
 * @param {{ locale: string, isB2bActive: boolean }} params
 * @returns {number}
 */
export function getQuestionResponseHours({ locale, isB2bActive }) {
  if (locale === 'en') {
    return 12;
  }
  return isB2bActive ? 6 : 8;
}
